var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgGroup(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 25
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#DBDBDB"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.848 9.692V22.64l-12.93 1.517v-12.95m0 .001l12.93-1.516M7.94 6.06l7.982-.937m-6.004 6.085v12.95l-6.925-4.551V6.658m0 0l6.925 4.55m12.93-1.534l3.495-5.746L18.705.566l-2.783 4.557m0 0l6.926 4.55m-6.926-4.55v5.381"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.098 11.188L7.361 4.686.828 1.517l2.165 5.141"
  }))));
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNyIgaGVpZ2h0PSIyNSIgdmlld0JveD0iMCAwIDI3IDI1Ij4KICAgIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCIgc3Ryb2tlPSIjREJEQkRCIj4KICAgICAgICA8cGF0aCBkPSJNMjIuODQ4IDkuNjkyVjIyLjY0bC0xMi45MyAxLjUxN3YtMTIuOTVNOS45MTggMTEuMjA4bDEyLjkzLTEuNTE2TTcuOTQgNi4wNmw3Ljk4Mi0uOTM3TTkuOTE4IDExLjIwOHYxMi45NWwtNi45MjUtNC41NTFWNi42NThNMi45OTMgNi42NThsNi45MjUgNC41NU0yMi44NDggOS42NzRsMy40OTUtNS43NDZMMTguNzA1LjU2NmwtMi43ODMgNC41NTdNMTUuOTIyIDUuMTIzbDYuOTI2IDQuNTVNMTUuOTIyIDUuMTIzdjUuMzgxIi8+CiAgICAgICAgPHBhdGggZD0iTTEwLjA5OCAxMS4xODhMNy4zNjEgNC42ODYuODI4IDEuNTE3bDIuMTY1IDUuMTQxIi8+CiAgICA8L2c+Cjwvc3ZnPgo=";
export { SvgGroup as ReactComponent };